import 'instantsearch.css/themes/algolia-min.css';
import React, { useState, useEffect } from 'react';

import {
    InstantSearch,
    connectStateResults,
    Hits,
    SortBy,
    // SearchBox,
    Highlight,
    ClearRefinements,
    RefinementList,
    Configure,
    Snippet,
    MenuSelect,
    connectPagination,
    RangeInput,
    HierarchicalMenu
    // connectMenu
} from 'react-instantsearch-dom';
import './App.css';
import { instantMeiliSearch } from '@meilisearch/instant-meilisearch';

// const SingleSelectMenu = ({ items, currentRefinement, refine, createURL }) => {
//     const defaultItems = ["Average", "Normalized Average", "Maximum"]
//     const [metric, setMetric] = useState("Average")
//     return (
//         <dl>
//             {defaultItems.map(item => (
//                 <dt key={item}>
//                     <a
//                         href={createURL(item)}
//                         style={{ fontWeight: metric === item ? 'bold' : '' }}
//                         onClick={event => {
//                             event.preventDefault();
//                             setMetric(item)
//                             if (metric !== item) {
//                                 refine(item);
//                             }
//                         }}
//                     >
//                         <input type="submit" className={metric === item ? 'menu-item selected' : 'menu-item'} value={item} ></input>
//                     </a>
//                 </dt>
//             ))}
//         </dl>)
// };



// const RankTypeMenu = connectMenu(SingleSelectMenu)

const searchClient = instantMeiliSearch(
    process.env.REACT_APP_MEILI_HOST,
    process.env.REACT_APP_MEILI_MASTER_KEY,
    {
        paginationTotalHits: 1000 // Max that instantsearch can use is 1000 hits
    }
);

const App = () => (
    <div className='ais-InstantSearch'>
        <h1>Storms Database Viewer</h1>
        <p>Development space for searching historic storms</p>
        <InstantSearch indexName='events' searchClient={searchClient}>
            <div className='left-panel'>
                <h3 className='left-header'>Sort by</h3>
                <SortBy
                    defaultRefinement='events:start.timestamp:asc'
                    items={[
                        {
                            value: 'events:start.timestamp:asc',
                            label: 'Start Date'
                        },
                        {
                            value: 'events:stats.mean:desc',
                            label: 'Accumulation - Mean'
                        },
                        {
                            value: 'events:stats.sum:desc',
                            label: 'Accumulation - Sum'
                        },
                        {
                            value: 'events:stats.max:desc',
                            label: 'Accumulation - Max'
                        },
                        {
                            value: 'events:stats.norm_mean:desc',
                            label: 'Accumulation - 2-yr Norm'
                        }
                    ]}
                />
                <h3 className='left-header'>Watersheds</h3>
                <HierarchicalMenu
                    attributes={[
                        'categories.lv10',
                        'categories.lv11',
                    ]}
                />
                <h3 className='left-header'>Rank By Year</h3>
                <RangeInput
                    attribute={'ranks.declustered_rank'}
                    min={1}
                    precision={0}
                />
                <h3 className='left-header'>Mean Accumulation</h3>
                <RangeInput
                    attribute={'stats.mean'}
                    min={0.00}
                    precision={2}
                />
                <h3 className='left-header'>Calendar Year</h3>
                <MenuSelect
                    attribute={'start.calendar_year'}
                    limit={50}
                    transformItems={(items) => items.sort((a, b) => a.label - b.label)}
                />
                <h3 className='left-header'>Water Year</h3>
                <MenuSelect
                    attribute={'start.water_year'}
                    limit={50}
                    transformItems={(items) => items.sort((a, b) => a.label - b.label)}
                />
                <h3 className='left-header'>Seasons</h3>
                <MenuSelect
                    attribute={'start.season'}
                    transformItems={(items) => items.sort((a, b) => a.label - b.label)}
                />
                <h3 className='left-header'>Duration</h3>
                <RefinementList attribute={'duration'} />

                {/* <h2 className='left-header'>Sources</h2>
                <RefinementList attribute='metadata.source' /> */}


                <ClearRefinements />

                <Configure
                    hitsPerPage={6}
                    attributesToSnippet={['description:50']}
                    snippetEllipsisText={'...'}
                />
            </div>

            <div className='right-panel'>
                <Hits hitComponent={Hit} />
                <CustomPagination />
            </div>
        </InstantSearch>
    </div>
);

const ImageHoverZoom = ({ origin, thumbnail }) => {
    return (
        <div className='img-wrapper'>
            <input type='checkbox' id={thumbnail} />
            <label for={thumbnail}>
                <img
                    // src={origin + thumbnail}
                    src={thumbnail}
                    align='left'
                    alt={thumbnail}
                    className='hover-zoom'
                // width={250} height={300}
                />
            </label>
        </div>
    );
};

const Hit = ({ hit }) => (
    <div>
        <div className='season'>{hit.start.season}</div>
        <div className='hit-title'>{hit.start.datetime.split(' ')[0]}</div>
        <ImageHoverZoom origin={window.location.origin} thumbnail={hit.metadata.png} />
        <div key={hit.id}>
            <div className='hit-name'>
                <Highlight attribute='name' hit={hit} />
            </div>
            <div className='description'>
                <Snippet attribute='description' hit={hit} />
                <div className='hit-info'>
                    Name: {hit.metadata.watershed_name}
                </div>
                <div className='hit-info'>
                    Domain: {hit.metadata.transposition_domain_name}
                </div>
                <div className='hit-info'>
                    Duration: {hit.duration}h
                </div>
                <div className='hit-info'>
                    Source: {hit.metadata.source}
                </div>
                <br />
                <div className='hit-info'>Accumulation (Inches)</div>
                <div className='hit-info'>
                    &ensp;min = {parseFloat(hit.stats.min).toFixed(2)}
                </div>
                <div className='hit-info'>
                    &ensp;mean = {parseFloat(hit.stats.mean).toFixed(2)}
                </div>
                <div className='hit-info'>
                    &ensp;max = {parseFloat(hit.stats.max).toFixed(2)}
                </div>
                <div className='hit-info'>
                    &ensp;sum = {parseFloat(hit.stats.sum).toFixed(2)}
                </div>
                <div className='hit-info'>
                    &ensp;2-yr norm = {parseFloat(hit.stats.norm_mean).toFixed(2)}
                </div>

                {/* <div className='hit-info'>
            <a href={hit.dss_file} download>Download DSS</a>
        </div> */}
                {/* <div className='hit-info'>{hit.rank_type}-{hit.rank_value}</div> */}
                {/* <div className='hit-info'>
          Max Long/Lat: {parseFloat(hit.max_point_xy[0]).toFixed(2)} {parseFloat(hit.max_point_xy[1]).toFixed(2)}
        </div> */}
            </div>
        </div>
    </div>
);

const Paginate = ({ currentRefinement, nbPages, refine, createURL }) => {
    const [totalPgs, setTotalPgs] = useState(0);

    return (
        <center>
            <CustomStateResults setTotalPgs={setTotalPgs} totalPgs={totalPgs} />
            <div className='pagination'>
                <a
                    href={createURL(1)}
                    key='«'
                    onClick={(event) => {
                        event.preventDefault();
                        refine(1);
                    }}
                >
                    <button disabled={currentRefinement <= 1 ? true : false}>«</button>
                </a>
                <a
                    href={createURL(currentRefinement - 1)}
                    key='‹'
                    onClick={(event) => {
                        event.preventDefault();
                        refine(currentRefinement - 1);
                    }}
                >
                    <button disabled={currentRefinement <= 1 ? true : false}>‹</button>
                </a>
                {new Array(totalPgs >= 7 ? 7 : totalPgs).fill(null).map((_, index) => {
                    let page = 0;
                    if (currentRefinement <= 3) {
                        page = index + 1;
                    } else if (currentRefinement > totalPgs - 3) {
                        page = totalPgs - 6 + index;
                    } else {
                        page = currentRefinement - 3 + index;
                    }
                    return (
                        <a
                            href={createURL(page)}
                            key={page}
                            onClick={(event) => {
                                event.preventDefault();
                                refine(page);
                            }}
                        >
                            <button className={currentRefinement === page ? 'active' : ''}>
                                {page}
                            </button>
                        </a>
                    );
                })}
                <a
                    href={createURL(currentRefinement + 1)}
                    key='›'
                    onClick={(event) => {
                        event.preventDefault();
                        refine(currentRefinement + 1);
                    }}
                >
                    <button disabled={currentRefinement >= totalPgs ? true : false}>
                        ›
                    </button>
                </a>
                <a
                    href={createURL(totalPgs)}
                    key='»'
                    onClick={(event) => {
                        event.preventDefault();
                        refine(totalPgs);
                    }}
                >
                    <button disabled={currentRefinement >= totalPgs ? true : false}>
                        »
                    </button>
                </a>
            </div>
        </center>
    );
};

const CustomPagination = connectPagination(Paginate);

const StateResults = ({ searchResults, setTotalPgs, totalPgs }) => {
    const hasResults = searchResults && searchResults.nbHits !== 0;
    const nbHits = searchResults && searchResults.nbHits;

    useEffect(() => {
        setTotalPgs(Math.ceil(nbHits / 6));
        console.log(totalPgs);
    }, [setTotalPgs, nbHits]);

    return (
        <div className='total-pages'>
            <div hidden={hasResults}>There is no results</div>
        </div>
    );
};

const CustomStateResults = connectStateResults(StateResults);

export default App;
